export enum SituacaoContaEnum {
  Ativa = '0',
  Inativa = '1',
  Bloqueada = '2'
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/SituacaoConta.enum.ts